import { createContext, useContext, ReactNode } from "react";

import {
  useUsersList,
  useUser,
  useCreateUser,
  useUpdateUser,
} from "@/hooks/useUsers";

interface UserContextType {
  useUsersList: typeof useUsersList;
  useUser: typeof useUser;
  useCreateUser: typeof useCreateUser;
  useUpdateUser: typeof useUpdateUser;
}

const UserContext = createContext<UserContextType | null>(null);

export function UserProvider({ children }: { children: ReactNode }) {
  const value = {
    useUsersList,
    useUser,
    useCreateUser,
    useUpdateUser,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
}
